module.exports = __webpack_public_path__ + "kit_1.jpg?2ecf7d574ad463e3dd823069beffdcf7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kit_1.jpg
// module id = 31
// module chunks = 0